import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import InvoiceUpdateModalUI from './InvoiceUpdateModalUI.js'

class InvoiceUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // update invoice
      submitted: false,
      // invoice name
      invoiceName: this.props.invoice.invoiceName,
      invoiceNameError: null,
    }
  }

  render() {
    return (
      <InvoiceUpdateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // update mode
        updateMode={this.props.updateMode}
        // invoice name
        invoiceName={this.state.invoiceName}
        onInvoiceNameChange={(event) => {this.setState({invoiceName: event.target.value})}}
        invoiceNameError={this.state.invoiceNameError}
        setInvoiceNameError={(error) => {this.setState({invoiceNameError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/invoices/${this.props.match.params.invoiceId}`,
      this.onSubmitCallback, {
        invoiceName: this.state.invoiceName,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'invoiceName':
          this.setState({invoiceNameError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 2000)
      this.props.onUpdateComplete(response.invoice)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      invoiceName: this.props.invoice.invoiceName,
      invoiceNameError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_update_invoice',
      'c_update',
      'c_cancel',
      'c_invoice_name',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('inv_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(InvoiceUpdateModalSF)
